import { OfferingSearchRequestQuery, OfferingSearchResponse } from '@lio/api-types';
import { offeringsQueryKey, getOfferingsQuery } from '@services/offering';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchPaginatedOfferings = (params: OfferingSearchRequestQuery) => {
  const client = useClient();
  const query = getOfferingsQuery(params);
  const result = useInfiniteQuery<OfferingSearchResponse, Error>({
    queryKey: offeringsQueryKey.searchWithParams(params),
    queryFn: ({ pageParam }) => client.get(`offering?${query}&pageOffset=${pageParam}`).json<OfferingSearchResponse>(),
    initialPageParam: 0,
    staleTime: 2000,
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.pagination) return undefined;
      if (!lastPage.pagination.pageLimit) return undefined;
      if (!lastPage.pagination.total) return undefined;
      const { total, pageLimit } = lastPage.pagination;
      const fetchedPageCount = allPages.length;
      const nextPageOffsetValue = fetchedPageCount * pageLimit;
      if (nextPageOffsetValue > total) return undefined;
      return nextPageOffsetValue;
    },
  });
  return { ...result, offerings: result.data };
};
